import { render, staticRenderFns } from "./historyCompare.vue?vue&type=template&id=c09f3ea0"
import script from "./historyCompare.vue?vue&type=script&lang=js"
export * from "./historyCompare.vue?vue&type=script&lang=js"
import style0 from "./historyCompare.vue?vue&type=style&index=0&id=c09f3ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports